import EntryPageCinema from "./cinemas/EntryPageCinema.svelte";
import LastSeenArticlesCinema from "./cinemas/LastSeenArticlesCinema.svelte";
import StorefrontTrendCinema from "./cinemas/StorefrontTrendCinema.svelte";
import EmptyBasketCinema from "./cinemas/EmptyBasketCinema.svelte";
import "custom-event-polyfill";
import WishlistCinema from "./cinemas/WishlistCinema.svelte";
import performanceFactory from "./performance/performance";
import AlternativeCinema from "./cinemas/AlternativeCinema.svelte";
import ComplementaryCinema from "./cinemas/ComplementaryCinema.svelte";
import ProductLineCinema from "./cinemas/ProductLineCinema.svelte";
import debug from "./qa/debug";
import BounceLayerCinema from "./cinemas/BounceLayerCinema.svelte";
import OrderOverviewCinema from "./cinemas/OrderOverviewCinema.svelte";
import { key as svgImageUrlPrefixCtxKey } from "./context/svgImageUrlPrefix";
import BasketLayerCinema from "./cinemas/BasketLayerCinema.svelte";
import PwyloCinema from "./cinemas/PwyloCinema.svelte";
import ajaxFetch from "./services/ajaxFetch.js";
import StorefrontCinema from "./cinemas/StorefrontCinema.svelte";
import BrandCinema from "./cinemas/BrandCinema.svelte";
import { mount } from "svelte";
import DealsCinema from "./cinemas/DealsCinema.svelte";

window.o_reco = window.o_reco || {};
window.o_reco.private = window.o_reco.private || {};
window.o_reco.private.readyToListen = true;
const loadRecommendationsForWishlist = ({ target, variationId, parentTrackingId, svgImageUrlPrefix = "" }) => {
    const cinemaInjectionContainerWidth = target.offsetWidth;
    mount(WishlistCinema, {
        target,
        props: {
            variationId,
            parentTrackingId,
            cinemaInjectionContainerWidth,
            errorCallback: () => target.remove(),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForWishlist = loadRecommendationsForWishlist;

const asyncLoadRecommendationsForDetailView = async ({
    variationId,
    topTarget,
    bottomTarget,
    prioTarget,
    eventMergeId,
    svgImageUrlPrefix = "",
}) => {
    const res = await ajaxFetch("/reco-core/recommendations/switchdetailview");
    const isSwitchDetailView = res.status !== 200 ? false : (await res.json()).switchDetailView;
    const newTopTarget = isSwitchDetailView ? prioTarget : topTarget;
    const newPriorTarget = isSwitchDetailView ? topTarget : prioTarget;

    if (newTopTarget) {
        const targetElement = document.querySelector(newTopTarget);
        if (targetElement) {
            const cinemaInjectionContainerWidth = targetElement.offsetWidth;
            mount(AlternativeCinema, {
                target: targetElement,
                props: {
                    variationId,
                    eventMergeId,
                    cinemaInjectionContainerWidth,
                    featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
                    performance: performanceFactory(window, 99),
                },
                context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
            });
        } else {
            debug.log("could not find target for alternative cinema css selector " + newTopTarget);
        }
    }

    if (bottomTarget) {
        const targetElement = document.querySelector(bottomTarget);
        if (targetElement) {
            const cinemaInjectionContainerWidth = targetElement.offsetWidth;
            mount(ComplementaryCinema, {
                target: targetElement,
                props: {
                    variationId,
                    eventMergeId,
                    cinemaInjectionContainerWidth,
                    featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
                    errorCallback: () => targetElement.remove(),
                    performance: performanceFactory(window, 99),
                },
                context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
            });
        } else {
            debug.log("could not find target for complementary cinema css selector " + bottomTarget);
        }
    }

    if (newPriorTarget) {
        const targetElement = document.querySelector(newPriorTarget);
        if (targetElement) {
            const cinemaInjectionContainerWidth = targetElement.offsetWidth;
            mount(ProductLineCinema, {
                target: targetElement,
                props: {
                    variationId,
                    eventMergeId,
                    cinemaInjectionContainerWidth,
                    featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
                    errorCallback: () => targetElement.remove(),
                    performance: performanceFactory(window, 99),
                },
                context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
            });
        } else {
            debug.log("could not find target for product line cinema css selector " + newPriorTarget);
        }
    }

    return Promise.resolve();
};
window.o_reco.private.asyncLoadRecommendationsForDetailView = asyncLoadRecommendationsForDetailView;

const loadBounceLayerCinema = ({ variationId, target, eventMergeId, svgImageUrlPrefix = "" }) => {
    if (target) {
        const targetElement = document.querySelector(target);
        if (targetElement) {
            const cinemaInjectionContainerWidth = targetElement.offsetWidth;
            mount(BounceLayerCinema, {
                target: targetElement,
                props: {
                    variationId,
                    eventMergeId,
                    cinemaInjectionContainerWidth,
                    featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
                    errorCallback: () => targetElement.remove(),
                    performance: performanceFactory(window, 99),
                },
                context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
            });
        } else {
            debug.log("could not find target for bounce layer cinema css selector " + target);
        }
    }
    return Promise.resolve();
};
window.o_reco.private.loadBounceLayerCinema = loadBounceLayerCinema;

const loadRecommendationsForOrderOverview = ({
    variationId,
    cinemaId,
    target,
    trackingData: additionalTrackingLabels,
    svgImageUrlPrefix = "",
}) => {
    const cinemaInjectionContainerWidth = target.offsetWidth;
    mount(OrderOverviewCinema, {
        target,
        props: {
            variationId,
            cinemaId,
            additionalTrackingLabels,
            cinemaInjectionContainerWidth,
            featureIndex: target.parentNode.dataset.featureOrder || "99",
            errorCallback: () => target.remove(),
            performance: performanceFactory(window, 99),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForOrderOverview = loadRecommendationsForOrderOverview;

const loadRecommendationsForEntryPage = ({
    targetElement,
    dresonRule,
    timelineEntryId,
    pageType,
    index,
    svgImageUrlPrefix = "",
    view,
}) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(EntryPageCinema, {
        target: targetElement,
        props: {
            contextDresonRule: dresonRule,
            timelineEntryId,
            view,
            pageType,
            index,
            cinemaInjectionContainerWidth,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            removeSkeleton: () => {
                targetElement.querySelector(".reco_entry_page_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_entry_page_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, index),
            additionalNextPiTrackingLabels: JSON.parse(targetElement.parentNode.dataset.nextPiTrackingLabels || null),
            additionalTrackingLabels: JSON.parse(targetElement.parentNode.dataset.featureTrackingLabels || null),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForEntryPage = loadRecommendationsForEntryPage;

const loadEntryPageCinemas = (selector) => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");

        const {
            encodedDresonRule: dresonRule,
            timelineEntryId,
            index,
            svgImageUrlPrefix,
            pageType,
            view,
        } = targetElement.dataset;

        loadRecommendationsForEntryPage({
            targetElement,
            dresonRule,
            timelineEntryId,
            pageType,
            index,
            svgImageUrlPrefix,
            view,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_entry_page", (selector) => {
    loadEntryPageCinemas(selector);
});
loadEntryPageCinemas(".reco_entrypage_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadRecommendationsForStorefront = ({ targetElement, index, svgImageUrlPrefix = "" }) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(StorefrontCinema, {
        target: targetElement,
        props: {
            index,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            removeSkeleton: () => {
                targetElement.querySelector(".reco_storefront_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_storefront_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, index),
            cinemaInjectionContainerWidth,
            additionalNextPiTrackingLabels: JSON.parse(targetElement.parentNode.dataset.nextPiTrackingLabels || null),
            additionalTrackingLabels: JSON.parse(targetElement.parentNode.dataset.featureTrackingLabels || null),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForStorefront = loadRecommendationsForStorefront;

const loadStorefrontCinema = (selector) => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");

        const { index, svgImageUrlPrefix } = targetElement.dataset;

        loadRecommendationsForStorefront({
            targetElement,
            index,
            svgImageUrlPrefix,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_storefront", (selector) => {
    loadStorefrontCinema(selector);
});
loadStorefrontCinema(".reco_storefront_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadLastSeenArticles = ({ targetElement, index, svgImageUrlPrefix = "" }) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    const { pageType } = targetElement.dataset;
    mount(LastSeenArticlesCinema, {
        target: targetElement,
        props: {
            index,
            cinemaInjectionContainerWidth,
            pageType,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            removeSkeleton: () => {
                targetElement.querySelector(".reco_last_seen_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_last_seen_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, index),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};

const loadLastSeenArticlesCinemas = (selector, svgImageUrlPrefix = "") => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");

        const { index } = targetElement.parentNode.dataset;

        loadLastSeenArticles({
            targetElement,
            index,
            svgImageUrlPrefix,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_last_seen_articles", (selector) => {
    loadLastSeenArticlesCinemas(selector);
});
loadLastSeenArticlesCinemas(".reco_lastSeenArticles_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadBasketLayer = ({ targetElement, variationId, svgImageUrlPrefix = "" }) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(BasketLayerCinema, {
        target: targetElement,
        props: {
            removeSkeleton: () => {
                targetElement.querySelector(".reco_basket_layer_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_basket_layer_skeleton_load_style");
            },
            variationId,
            cinemaInjectionContainerWidth,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, 99),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};

const loadBasketLayerCinema = (selector, svgImageUrlPrefix = "") => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        if (targetElement) {
            const { variationId } = targetElement.dataset;
            targetElement.classList.remove("reco_skeleton_needsInitialization");
            loadBasketLayer({
                targetElement,
                variationId,
                svgImageUrlPrefix,
            }).catch(function (error) {
                console.error(error);
            });
        } else {
            debug.log("could not find target for basketlayer cinema css selector " + selector);
        }
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_basket_layer", (selector) => {
    loadBasketLayerCinema(selector);
});
loadBasketLayerCinema(".reco_basketlayer_skeleton_injection_container.reco_skeleton_needsInitialization");

window.o_reco.private.loadBasketLayerCinema = loadBasketLayerCinema;

const loadEmptyBasket = ({ targetElement, index, eventMergeId, svgImageUrlPrefix = "" }) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(EmptyBasketCinema, {
        target: targetElement,
        props: {
            targetElement,
            index,
            eventMergeId,
            cinemaInjectionContainerWidth,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            removeSkeleton: () => {
                targetElement.querySelector(".reco_empty_basket_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_empty_basket_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, index),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
const loadEmptyBasketCinemas = (selector, svgImageUrlPrefix = "", eventMergeId) => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");

        const { index } = targetElement.parentNode.dataset;

        loadEmptyBasket({
            targetElement,
            index,
            eventMergeId,
            svgImageUrlPrefix,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_empty_basket", (payload) => {
    if (typeof payload === "string") {
        const eventMergeId = document.getElementsByClassName("or_js_eventMergeId")?.[0]?.dataset?.eventMergeId;
        loadEmptyBasketCinemas(payload, undefined, eventMergeId);
    } else if (typeof payload === "object") {
        const { selector, eventMergeId } = payload;

        loadEmptyBasketCinemas(selector, undefined, eventMergeId);
    }
});
loadEmptyBasketCinemas(".reco_emptyBasket_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadStorefrontTrend = ({ targetElement, index }) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(StorefrontTrendCinema, {
        target: targetElement,
        props: {
            index,
            removeSkeleton: () => {
                targetElement.querySelector(".reco_trend_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_trend_skeleton_load_style");
            },
            cinemaInjectionContainerWidth,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, index),
            additionalTrackingLabels: JSON.parse(targetElement.parentNode.dataset.featureTrackingLabels || null),
        },
    });
    return Promise.resolve();
};

const loadStorefrontTrendCinemas = (selector, svgImageUrlPrefix = "") => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");
        loadStorefrontTrend({
            targetElement,
            index: "0",
            svgImageUrlPrefix,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_trend_reco", (selector) => {
    loadStorefrontTrendCinemas(selector);
});
loadStorefrontTrendCinemas(".reco_trend_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadRecommendationsForPwylo = ({ targetElement, index, svgImageUrlPrefix = "" }) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(PwyloCinema, {
        target: targetElement,
        props: {
            index,
            cinemaInjectionContainerWidth,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            removeSkeleton: () => {
                targetElement.querySelector(".reco_pwylo_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_pwylo_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, index),
            additionalTrackingLabels: JSON.parse(targetElement.parentNode.dataset.featureTrackingLabels || null),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForPwylo = loadRecommendationsForPwylo;

const loadPwyloCinemas = (selector) => {
    const cinema_injection_containers = document.querySelectorAll(selector);

    for (const targetElement of cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");

        const { svgImageUrlPrefix } = targetElement.dataset;

        loadRecommendationsForPwylo({
            targetElement,
            index: "0",
            svgImageUrlPrefix,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_pwylo", (selector) => {
    loadPwyloCinemas(selector);
});
loadPwyloCinemas(".reco_pwylo_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadRecommendationsForBrand = ({
    targetElement,
    dresonRule,
    timelineEntryId,
    index,
    view,
    svgImageUrlPrefix = "",
}) => {
    const cinemaInjectionContainerWidth = targetElement.offsetWidth;
    mount(BrandCinema, {
        target: targetElement,
        props: {
            contextDresonRule: dresonRule,
            index,
            timelineEntryId,
            cinemaInjectionContainerWidth,
            view,
            featureIndex: targetElement.parentNode.dataset.featureOrder || "99",
            removeSkeleton: () => {
                targetElement.querySelector(".reco_brand_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_brand_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, 99),
            additionalNextPiTrackingLabels: JSON.parse(targetElement.parentNode.dataset.nextPiTrackingLabels || null),
            additionalTrackingLabels: JSON.parse(targetElement.parentNode.dataset.featureTrackingLabels || null),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForBrand = loadRecommendationsForBrand;

const loadBrandCinema = (selector) => {
    const targetElement = document.querySelector(selector);
    if (!targetElement) {
        return;
    }
    targetElement.classList.remove("reco_skeleton_needsInitialization");

    const { encodedDresonRule: dresonRule, timelineEntryId, index, view, svgImageUrlPrefix } = targetElement.dataset;

    loadRecommendationsForBrand({
        targetElement,
        dresonRule,
        timelineEntryId,
        index,
        view,
        svgImageUrlPrefix,
    }).catch(function (error) {
        console.error(error);
    });
};

o_global.eventQBus.on("ft6bcn.reco.start_brand", (selector) => {
    loadBrandCinema(selector);
});
loadBrandCinema(".reco_brand_skeleton_injection_container.reco_skeleton_needsInitialization");

const loadRecommendationsForDeals = ({ targetElement, dresonRule, svgImageUrlPrefix = "" }) => {
    const dealBlockContainer = document.querySelector("#product-highlight-dealblock");
    const cinemaInjectionContainerWidth = dealBlockContainer
        ? dealBlockContainer.offsetWidth
        : targetElement.offsetWidth;
    mount(DealsCinema, {
        target: targetElement,
        props: {
            contextDresonRule: dresonRule,
            removeSkeleton: () => {
                targetElement.querySelector(".reco_deals_skeleton_placeholder")?.remove();
                targetElement.classList.remove("reco_deals_skeleton_load_style");
            },
            errorCallback: () => targetElement.remove(),
            performance: performanceFactory(window, 99),
            cinemaInjectionContainerWidth,
            featureIndex: targetElement.closest("[data-feature-order]")?.dataset.featureOrder || "99",
            additionalNextPiTrackingLabels: JSON.parse(
                targetElement.closest("[data-next-pi-tracking-labels]")?.dataset.nextPiTrackingLabels || null
            ),
            additionalTrackingLabels: JSON.parse(
                targetElement.closest("[data-feature-tracking-labels]")?.dataset.featureTrackingLabels || null
            ),
        },
        context: new Map([[svgImageUrlPrefixCtxKey, svgImageUrlPrefix]]),
    });
    return Promise.resolve();
};
window.o_reco.private.loadRecommendationsForDeals = loadRecommendationsForDeals;

const loadDealsCinemas = (selector) => {
    const deal_cinema_injection_containers = document.querySelectorAll(selector);
    for (const targetElement of deal_cinema_injection_containers) {
        targetElement.classList.remove("reco_skeleton_needsInitialization");

        const { encodedDresonRule: dresonRule } = targetElement.dataset;

        loadRecommendationsForDeals({
            targetElement,
            dresonRule,
        }).catch(function (error) {
            console.error(error);
        });
    }
};

o_global.eventQBus.on("ft6bcn.reco.start_deals", (selector) => {
    loadDealsCinemas(selector);
});
loadDealsCinemas(".reco_deals_skeleton_injection_container.reco_skeleton_needsInitialization");
